// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"873ac375","455":"f693ca78","977":"f41ac508"}[chunkId] + ".chunk.js";
};